import { Box, Typography } from "@mui/material";
import React from "react";
import CustomBadge from "../../../../components/CustomBadge";
import StepsItem from "./StepItem";
interface Props {
  activeIndex: number;
  getStep: (index: number) => void;
}
export default function StepsItems({ activeIndex, getStep }: Props) {
  const steps: {
    index: number;
    title: string;
    status: "pending" | "inprogress" | "done";
  }[] = [
    {
      index: 1,
      title: "مشخصات ناوگان",
      status: activeIndex === 1 ? "inprogress" : "pending",
    },
    {
      index: 2,
      title: "بارگذاری مدارک",
      status: activeIndex === 2 ? "inprogress" : "pending",
    },
    {
      index: 3,
      title: "محل سکونت",
      status: activeIndex === 3 ? "inprogress" : "pending",
    },
    {
      index: 4,
      title: "حساب بانکی",
      status: activeIndex === 4 ? "inprogress" : "pending",
    },
  ];

  return (
    <Box
      sx={{
        marginTop: "16px",
        border: "1px solid gray",
        backgroundColor: "background.default",
        borderRadius: "16px",
        display: "flex",
        alignItems: "center",
        padding: "16px",
      }}
    >
      {steps.map((item) => (
        <StepsItem getStep={getStep} data={item} />
      ))}
    </Box>
  );
}
